import { render, staticRenderFns } from "./AdministrativeProcurementB.vue?vue&type=template&id=de23957a&scoped=true"
import script from "./AdministrativeProcurementB.vue?vue&type=script&lang=js"
export * from "./AdministrativeProcurementB.vue?vue&type=script&lang=js"
import style0 from "./AdministrativeProcurementB.vue?vue&type=style&index=0&id=de23957a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de23957a",
  null
  
)

export default component.exports